import { NotificationEventItem } from 'shared'
import { CIMSNotificationsProps } from './types'
import { Button, Row, Space, Typography } from 'antd'
import PanelContent from './components/PanelContent'
import CIMSNotificationsProvider from './CIMSNotificationsContext'
import PanelHeader from './components/PanelHeader'
import CIMSNotificationsPanelProvider from './components/CIMSNotificationsPanelContext'
import CIMSCollapse from '../CIMSCollapse'
import { Store } from 'antd/lib/form/interface'

/**
 * @see {@link CIMSNotificationsProps}
 * @see library.notificationEvents.readme.md
 */
function CIMSNotifications<
  Item extends NotificationEventItem,
  InitialValues extends Store
>({
  events,
  compareFn,
  details,
  loading,
  __debug,
  onReload,
  ...rest
}: CIMSNotificationsProps<Item, InitialValues>) {
  const sorted = Array.of(...events)
  if (compareFn) sorted.sort(compareFn)
  if (__debug) {
    console.groupCollapsed('CIMSNotifications')
    console.log('sort', compareFn)
    console.log('sorted', sorted)
    console.groupEnd()
  }
  return (
    <CIMSNotificationsProvider
      {...rest}
      onReload={onReload}
      __debug={__debug}
      loading={loading}
    >
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Row justify="space-between" align="bottom" wrap={false}>
          <Space size="small" direction="vertical">
            <Typography.Paragraph>
              Assign Users, or Non User Emails, to the following notification
              events
            </Typography.Paragraph>
            {details && details}
          </Space>
          {onReload && (
            <Button
              loading={loading}
              disabled={loading}
              onClick={() => onReload()}
            >
              Reload
            </Button>
          )}
        </Row>
        <CIMSCollapse
          loading={loading}
          noPanelsContent={
            <Typography.Paragraph type="danger" strong>
              Cannot render CIMSNotifications without events
            </Typography.Paragraph>
          }
          panels={sorted.map((event) => ({
            key: event.id,
            header: {
              children: <PanelHeader event={event} />,
            },
            children: (
              <CIMSNotificationsPanelProvider event={event}>
                <PanelContent />
              </CIMSNotificationsPanelProvider>
            ),
          }))}
        />
      </Space>
    </CIMSNotificationsProvider>
  )
}

export default CIMSNotifications
